const classes = {
  notes: {
    color: 'grey.800',
    fontSize: '12px',
    fontWeight: 400,
  },
};

export default classes;
